/* MUI */
import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* React */
import React from 'react';

import { PAGE_HEADER_HEIGHT } from './constants';

export const PageHeader = ({ title }: { title: string }) => {
    const theme = useTheme();
    return (
        <Paper
            elevation={0}
            sx={{
                borderBottom: '1px solid',
                borderColor: theme.palette.border.pageHeader,
                borderRadius: 0,
                height: PAGE_HEADER_HEIGHT,
                paddingX: '24px',
                paddingY: '16px'
            }}
        >
            <Typography variant="h2">{title}</Typography>
        </Paper>
    );
};
